import api from "./api";
import TokenService from "./token.service";
import jwt_decode from "jwt-decode";
import { catchLoginError } from "./catchErrors";

class AuthService {
    async login({ username, password }) {
        const { data } = await api
            .post("/api/login_check", {
                username,
                password
            })
            .catch(catchLoginError);

        if (!data.token) {
            return Promise.reject();
        }

        const user = this.buildUserFromToken(data.token, data.refresh_token);

        await TokenService.setUser(user);

        return user;
    }

    async impersonate(impersonationToken) {
        const { data } = await api.post(`/api/impersonate/${impersonationToken}/consume`);

        if (!data.token) {
            return Promise.reject();
        }

        const user = this.buildUserFromToken(data.token);

        await TokenService.setUser(user);

        return user;
    }

    buildUserFromToken(token, refreshToken = null) {
        const userData = jwt_decode(token);

        return {
            refreshToken,
            token,
            uuid: userData.uuid,
            name: userData.name,
            role: userData.roles,
            color: userData.color,
            initials: userData.initials,
            settings: userData.settings
        };
    }

    logout() {
        TokenService.removeUser();
    }

    resetPasswordRequest(email) {
        return api.post('/api/recovery/reset', {
            email
        })
    }

    checkResetPasswordToken(token) {
        return api.get(`/api/recovery/${token}`);
    }

    resetPassword(token, password) {
        return api.post(`/api/recovery/${token}/change`, {
            password
        })
    }
}

export default new AuthService();